var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2,
    fill: "#2C6CA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.62938 4.75164C3.58626 4.57968 3.59339 4.39896 3.64993 4.23094C3.70647 4.06292 3.81004 3.91465 3.94834 3.80374C4.08665 3.69283 4.25388 3.62395 4.43017 3.60526C4.60646 3.58657 4.78442 3.61887 4.9429 3.69832L13.8889 8.1713C14.0429 8.24816 14.1725 8.36642 14.263 8.51282C14.3536 8.65922 14.4016 8.82795 14.4016 9.0001C14.4016 9.17224 14.3536 9.34098 14.263 9.48737C14.1725 9.63377 14.0429 9.75203 13.8889 9.82889L4.9429 14.3019C4.78442 14.3813 4.60646 14.4136 4.43017 14.3949C4.25388 14.3762 4.08665 14.3074 3.94834 14.1965C3.81004 14.0855 3.70647 13.9373 3.64993 13.7693C3.59339 13.6012 3.58626 13.4205 3.62938 13.2486L4.56617 9.5024L10.0061 9.0001L4.56617 8.4978L3.62938 4.75164Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/SendIcon.4d7135f494af65f190bbeba85fcbfc82.svg";
export { ForwardRef as ReactComponent };